<template>
    <iframe :src="buildIframeUrl" :title="iframeTitle" frameborder="0"></iframe>
</template>
<script>
export default {
    props: {
        urlForShare: {
            type: String,
            required: true,
        },
        iframeTitle: {
            type: String,
            default: 'QR Code',
        },
    },
    data() {
        return {
            makeaqrUrl: 'https://makeaqr.publica.la/',
        };
    },
    computed: {
        buildIframeUrl() {
            return encodeURI(
                `${this.makeaqrUrl}?url=${encodeURIComponent(this.urlForShare)}&show_action_buttons=false`
            );
        },
    },
};
</script>

<style lang="scss" scoped>
iframe {
    width: 100%;
    height: 100%;
    min-width: 200px;
    min-height: 230px;
}
</style>
